"use strict";
function popFromObject(object, key) {
    if (object) {
        var value = object[key];
        delete object[key];
        return value;
    }
}
exports.popFromObject = popFromObject;



//////////////////
// WEBPACK FOOTER
// ./node_modules/coveo.analytics/dist/utils.js
// module id = 315
// module chunks = 88 89